/**
 * Themen des Kontaktformulars.
 *
 * "order_status" und "presales" waren frueher ein gemeinsames "orders". Die
 * Aufteilung hat zwei Gruende: nur beim ersten ist eine Bestellnummer sinnvoll
 * erzwingbar, und Vorkauf-Anfragen sind offene Bestellungen, die im Desk
 * sichtbar priorisiert gehoeren.
 */
export const SUPPORT_TOPICS = ["order_status", "presales", "returns", "partnership", "other"] as const;

export type SupportTopic = (typeof SUPPORT_TOPICS)[number];

/** Altwert aus der Zeit vor der Aufteilung. Deep-Links und das Konto-Formular nutzen ihn noch. */
const LEGACY_TOPIC_ALIASES: Record<string, SupportTopic> = { orders: "order_status" };

export function normalizeTopic(raw: string): SupportTopic | null {
	if ((SUPPORT_TOPICS as readonly string[]).includes(raw)) return raw as SupportTopic;
	return LEGACY_TOPIC_ALIASES[raw] ?? null;
}

const REQUIRES_ORDER_NUMBER: ReadonlySet<SupportTopic> = new Set(["order_status", "returns"]);

export function topicRequiresOrderNumber(topic: SupportTopic): boolean {
	return REQUIRES_ORDER_NUMBER.has(topic);
}

const CHATWOOT_LABELS: Record<SupportTopic, string> = {
	order_status: "bestellung",
	presales: "vorkauf",
	returns: "retoure",
	partnership: "partnerschaft",
	other: "sonstiges",
};

export function chatwootLabelForTopic(topic: SupportTopic): string {
	return CHATWOOT_LABELS[topic];
}
